import { PercentileTag } from './percentile-tag';

export * from './percentile-highlight.enum';

export default PercentileTag;
